import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import moment from 'moment';

@Component({
  standalone: false,
  selector: 'ingsv-adm-input-date',
  templateUrl: './input-date.component.html',
  styleUrls: ['./input-date.component.scss']
})
export class InputDateComponent implements OnChanges {
  @Input() date = '';
  @Input() placeholder = '';
  @Output() dateChanged: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.date) {
      setTimeout(() => {
        (<HTMLInputElement>document.getElementById('date-input')).value = this.date;
      });
    }
  }

  chosenDateHandler(): void {
    const dateToSet = moment(this.date).format('YYYY-MM-DD');

    this.dateChanged.emit(dateToSet);
  }
}
